import { FileInputButton } from '@/components/FileInput';
import { ImageCropComponent } from '@/components/images/ImageCropComponent';
import { modalStyle } from '@/components/modalStyle';
import { CreateExerciseCategoryDTO, ExerciseCategoryDTO } from '@/generated';
import { useCreateExerciseCategory, useUpdateExerciseCategory } from '@/hooks/category-mutation.hooks';
import { uploadFile } from '@/utils/api-helpers';
import { objectHasId } from '@/utils/create-mode-helper';
import { Photo } from '@mui/icons-material';
import { Box, Button, Grid, Modal, TextField, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useState } from 'react';
import { ExternalLinksComponent } from '../exercises/elements/ExternalLinksComponent';

export interface UpdateExerciseCategoryModalProps {
  category?: ExerciseCategoryDTO | CreateExerciseCategoryDTO;
  setCategory: (e?: ExerciseCategoryDTO | CreateExerciseCategoryDTO) => void;
}

export const UpdateExerciseCategoryModal = (props: UpdateExerciseCategoryModalProps) => {
  const { category, setCategory } = props;
  const [imageFile, setImageFile] = useState<File | null | undefined>();
  const isEditMode = category ? objectHasId(category) : false;
  const createExerciseCategoryMutation = useCreateExerciseCategory();
  const updateExerciseCategoryMutation = useUpdateExerciseCategory();

  return category ? (
    <Modal open={category !== undefined} onClose={() => setCategory()}>
      <Box sx={modalStyle}>
        <Typography variant="h5">{isEditMode ? 'Edit Category' : 'Create Category'} </Typography>
        <TextField fullWidth value={category.name} style={{ marginTop: 30 }} onChange={(e) => setCategory({ ...category, name: e.target.value })} label="Name" />
        <TextField
          sx={{ my: 1 }}
          fullWidth
          value={category.description}
          label={'Category Description'}
          onChange={(v) => setCategory({ ...category, description: v.target.value })}
          multiline
          rows={4}
        />
        <Grid size={{ md: 6, xs: 12 }}>
          <ExternalLinksComponent objectWithLinks={category} setObjectsWithLinks={setCategory} />
        </Grid>
        <Box sx={{ m: 1 }}>
          <ImageCropComponent imageFile={imageFile} onImageFileChanged={setImageFile} imageId={category.imageId} />
          <Box sx={{ mt: 5, mb: 3, columnGap: 2, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
            <FileInputButton accept=".png,.jpg,.jpeg" startIcon={<Photo />} onFilePicked={(f) => setImageFile(f)}>
              Change Image
            </FileInputButton>
          </Box>
        </Box>

        <Button
          style={{ marginTop: 10 }}
          onClick={async () => {
            try {
              let fileId = undefined;
              let cat = category;
              if (imageFile) {
                fileId = await uploadFile(imageFile);
                cat = { ...cat, imageId: fileId };
              }

              if (objectHasId(cat)) {
                await updateExerciseCategoryMutation.mutateAsync(cat);
                enqueueSnackbar('Category updated!');
              } else {
                const e = await createExerciseCategoryMutation.mutateAsync(cat);
                enqueueSnackbar('Category created!');
              }
            } catch (e) {
              if (e instanceof Error) {
                enqueueSnackbar(JSON.parse(e.message).message, { variant: 'error' });
              }
            } finally {
              setCategory(undefined);
            }
          }}
        >
          Save
        </Button>
        <Button style={{ marginTop: 10 }} onClick={() => setCategory(undefined)}>
          Close
        </Button>
      </Box>
    </Modal>
  ) : (
    <></>
  );
};
